import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";

function authHeader() {
  return {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
}

export async function listBackups(params) {
  try {
    return await axios
      .get(`${baseUrl}/listbackups`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function createBackup(data) {
  try {
    return await axios
      .post(`${baseUrl}/createbackup`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function downloadBackup(id) {
  try {
    return await axios.get(`${baseUrl}/downloadbackup/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      responseType: "blob",
    });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteBackup(id) {
  try {
    return await axios
      .get(`${baseUrl}/deletebackup/${id}`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function restoreBackup(id) {
  try {
    return await axios
      .post(`${baseUrl}/restorebackup/${id}`, {}, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function listBackupSchedules() {
  try {
    return await axios
      .get(`${baseUrl}/listbackupschedules`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function createBackupSchedule(data) {
  try {
    return await axios
      .post(`${baseUrl}/createbackupschedule`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function updateBackupSchedule(id, data) {
  try {
    return await axios
      .post(`${baseUrl}/updatebackupschedule/${id}`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteBackupSchedule(id) {
  try {
    return await axios
      .get(`${baseUrl}/deletebackupschedule/${id}`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function getDatabaseTables() {
  try {
    return await axios
      .get(`${baseUrl}/getdatabasetables`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
